import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent implements OnInit {

  @Input() title : string;
  @Input() subTitle: string
  @Input() description: string
  @Input() content: any
  @Input() type: string
  @Input() style: any;

  constructor() { }

  ngOnInit(): void {
    console.log(this.style)

  }

  getBorderColor(){
    if(this.style && this.style['borderColor']){
      return this.style['borderColor']
    }
    return '#d3d3d3'
  }

}
